import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Building, ChevronDown, ChevronUp } from "lucide-react";

export const FISCAL_FIELDS = [
  ["company", "Ragione sociale"], ["vat", "Partita IVA"], ["tax_code", "Codice fiscale"], ["address", "Indirizzo"],
  ["zip", "CAP"], ["city", "Città"], ["province", "Provincia (sigla)"], ["sdi", "Codice SDI"], ["pec", "PEC"], ["email", "Email ricevute"], ["phone", "Telefono"],
];

export const FiscalFields = ({ form, setForm, inputCls = "", prefix = "fiscal" }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
    {FISCAL_FIELDS.map(([k, label]) => (
      <div key={k} className={k === "company" || k === "address" ? "sm:col-span-2" : ""}>
        <label className="order-field-label">{label}</label>
        <Input value={form[k] || ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} data-testid={`${prefix}-${k}`} className={inputCls} />
      </div>
    ))}
  </div>
);

export const TenantFiscalForm = () => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/billing/fiscal").then(({ data }) => setForm(data || {})).catch(() => setForm({})); }, []);
  if (!form) return null;
  const complete = !!(form.company && (form.vat || form.tax_code));
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const { data } = await api.put("/billing/fiscal", form); setForm(data); toast.success("Dati fiscali salvati: verranno usati sulle prossime ricevute"); setOpen(false); }
    catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="border-t border-zinc-800 pt-3" data-testid="billing-fiscal">
      <button type="button" onClick={() => setOpen(!open)} data-testid="billing-fiscal-toggle" className="w-full flex items-center justify-between text-sm">
        <span className="flex items-center gap-2 font-semibold"><Building className="h-4 w-4" /> Dati fiscali per le ricevute</span>
        <span className="flex items-center gap-2 text-xs">
          <span className={`pill ${complete ? "bg-emerald-500/15 text-emerald-600" : "bg-amber-500/15 text-amber-600"}`} data-testid="billing-fiscal-status">{complete ? form.company : "da compilare"}</span>
          {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
        </span>
      </button>
      {open && (
        <form onSubmit={save} className="mt-3 space-y-3">
          <p className="text-[11px] text-zinc-500">Le ricevute di pagamento del canone verranno intestate a questi dati. Senza dati compilati la ricevuta riporta il nome del club e l'email dell'admin.</p>
          <FiscalFields form={form} setForm={setForm} />
          <Button type="submit" size="sm" disabled={busy} data-testid="billing-fiscal-save" className="bg-[color:var(--vivi)] text-white">{busy ? "Salvo…" : "Salva dati fiscali"}</Button>
        </form>
      )}
    </div>
  );
};

export default TenantFiscalForm;
